import { render } from "./UiPopover.vue?vue&type=template&id=db87a130"
import script from "./UiPopover.vue?vue&type=script&lang=js"
export * from "./UiPopover.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__